import { render, staticRenderFns } from "./custom-page.vue?vue&type=template&id=2e9988a3&scoped=true&"
import script from "./custom-page.vue?vue&type=script&lang=js&"
export * from "./custom-page.vue?vue&type=script&lang=js&"
import style0 from "./custom-page.vue?vue&type=style&index=0&id=2e9988a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9988a3",
  null
  
)

export default component.exports